import { Colors } from 'src/assets/js/colors';

/*SERVICES*/
import { AuthService } from './services/auth/auth.service';

/*MODULES*/
import { VerificationModalComponent } from './components/ui/verification-modal/verification-modal.component';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { SidebarModule } from './shared/sidebar/sidebar.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ToastrModule } from 'ngx-toastr';
import { DateAdapter } from '@angular/material/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import localeEs from '@angular/common/locales/es';
import { CookieService } from 'ngx-cookie-service';
import { MarkdownModule } from 'ngx-markdown';

/*PIPES*/
import { UndefinedsPipe } from './services/pipes/undefineds/undefineds.pipe';
import { FilterLogsPipe } from './services/pipes/logsFilter/filter-logs.pipe';
import { AbsPipe } from './services/pipes/abs';
import { StringifyPipe } from './services/pipes/stringify';
import { CustomDateAdapter } from './custom-date.adapter';
import { CapitalizeFirstPipe } from './services/pipes/capitalizeFirst';
import { CommaToSlashPipe } from './services/pipes/commaToSlash/commaToSlash.pipe';
import { TestersSearchPipe } from './services/pipes/testers-search.pipe';
import { JsonStringifyPipe } from './services/pipes/json-stringify.pipe';
import { MarkdownPipe } from './services/pipes/markdown.pipe';
import { RemoveBulletPipe } from './services/pipes/remove-bullet.pipe';



/*TRANSLATIONS*/
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/*ANGULAR MATERIAL - Ampliado con módulos del shared*/
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';

/*SHARED COMPONENTS - Movidos del shared module*/
import { FileUploadExportComponent } from './shared/components/file-upload-export/file-upload-export.component';
import { CrudModalComponent } from './shared/components/modals/crud-modal/crud-modal.component';

/*COMPONENTS*/
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { DeviceComponent } from './pages/device/device.component';
import { SettingsComponent } from './pages/device/settings/settings.component';
import { DeviceDashboardComponent } from './pages/device/device-dashboard/device-dashboard.component';
import { ConnectivityComponent } from './pages/device/settings/connectivity/connectivity.component';
import { PasswordComponent } from './pages/device/settings/password/password.component';
import { WifiComponent } from './pages/device/settings/wifi/wifi.component';
import { ChannelsComponent } from './pages/device/settings/channels/channels.component';
import { PowerComponent } from './pages/device/settings/power/power.component';
import { OcppComponent } from './pages/device/settings/ocpp/ocpp.component';
import { ErrorModalComponent } from './components/ui/error-modal/error-modal.component';
import { ModernErrorModalComponent } from './components/ui/modern-error-modal/modern-error-modal.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { RegisterComponent } from './pages/register/register.component';
import { CardStateComponent } from './components/device-cards/card-state/card-state.component';
import { FooterComponent } from './shared/footer/footer.component';
import { CardHistoricComponent } from './components/card-historic/card-historic.component';
import { LoadingPopupComponent } from './components/ui/loading-popup/loading-popup.component';
import { AllSettingsComponent } from './pages/device/settings/all-settings/all-settings.component';
import { AdminComponent } from './pages/admin/admin.component';
import { AdminSearchComponent } from './pages/admin/admin-search/admin-search.component';
import { RfidComponent } from './pages/device/settings/rfid/rfid.component';
import { LogsComponent } from './pages/admin/logs/logs.component';
import { FwupdateComponent } from './pages/device/settings/fwupdate/fwupdate.component';
import { RecoveryComponent } from './pages/recovery/recovery.component';
import { ForgotComponent } from './pages/recovery/forgot/forgot.component';
import { CustomModalComponent } from './components/ui/custom-modal/custom-modal.component';
import { ModalConfirmComponent } from './components/ui/modal-confirm/modal-confirm.component';
import { AddDeviceComponent } from './pages/admin/add-device/add-device.component';
import { ModalSelectSerialComponent } from './components/ui/modal-select-serial/modal-select-serial.component';
import { ChargeSchedulerComponent } from './pages/device/settings/charge-scheduler/charge-scheduler.component';
import { PowerSchedulerComponent } from './pages/device/settings/power-scheduler/power-scheduler.component';
import { ModalSchedulerTaskComponent } from './components/ui/modal-scheduler-task/modal-scheduler-task.component';
import { AlertsDiagnosisComponent } from './components/ui/alerts-diagnosis/alerts-diagnosis.component';
import { SolarPriorityModalComponent } from './components/ui/solar-priority-modal/solar-priority-modal.component';
import { EthernetComponent } from './pages/device/settings/ethernet/ethernet.component';
import { ModulesComponent } from './pages/device/modules/modules.component';
import { MqttApiComponent } from './pages/developers/documentation/mqtt-api/mqtt-api.component';
import { DeveloperLayoutComponent } from './layouts/developer-layout/developer-layout.component';
import { CardAnalyticsComponent } from './components/card-analytics/card-analytics.component';
import { ResetComponent } from './pages/device/settings/reset/reset.component';
import { MultipleCommandComponent } from './pages/admin/multiple-command/multiple-command.component';
import { ModalMainMeterComponent } from './components/ui/modal-mainMeter/modal-mainMeter.component';
import { ModalSecondaryMeterComponent } from './components/ui/modal-secondaryMeter/modal-secondaryMeter.component';
import { PowerNewComponent } from './pages/device/settings/power-new/power-new.component';
import { TestersComponent } from './pages/admin/testers/testers.component';
import { MapGroupComponent } from './pages/group/map-group/map-group.component';
import { CostsComponent } from './pages/group/costs/costs.component';
import { FiltersTimeComponent } from './components/filters-time/filters-time.component';


//Firebase
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';

import { environment } from '../environments/environment';
import { PatTokenComponent } from './pages/developers/settings/pat-token/pat-token.component';

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DeviceSettingsSplComponent } from './pages/device/device-settings-spl/device-settings-spl.component';
import { DiagnosisHomeComponent } from './pages/device/diagnosis-home/diagnosis-home.component';
import { LinkageComponent } from './pages/device/settings/linkage/linkage.component';
import { ModalCheckComponent } from './components/ui/modal-check/modal-check.component';
import { GeolocationComponent } from './pages/device/settings/geolocation/geolocation.component';
import { NameComponent } from './pages/device/settings/name/name.component';
import { MqttComponent } from './pages/device/settings/mqtt/mqtt.component';
import { NewGroupComponent } from './pages/group/new-group/new-group.component';
import { ViewGroupComponent } from './pages/group/view-group/view-group.component';
import { ModalAddGroupComponent } from './components/ui/modal-add-group/modal-add-group.component';
import { SplGroupComponent } from './pages/group/spl-group/spl-group.component';
import { ShowGroupComponent } from './pages/group/show-group/show-group.component';
import { ShowGroupCtmComponent } from './pages/group/show-group/show-group-ctm/show-group-ctm.component';
import { SubscriptionsComponent } from './pages/device/subscriptions/subscriptions.component';
import { GroupComponent } from './pages/group/group.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PowerCircleComponent } from './components/power-circle/power-circle.component';
import { EnergyFlowLineComponent } from './components/energy-flow-line/energy-flow-line.component';
import { ModalCookiesComponent } from './components/ui/modal-cookies/modal-cookies.component';
import { ConfirmationModalComponent } from './shared/components/modals/confirmation-modal/confirmation-modal.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { NewLoginComponent } from './pages/new-login/new-login.component';
import { ElectricityRateComponent } from './pages/device/settings/electricity-rate/electricity-rate.component';
import { HourlyRateComponent } from './pages/device/settings/hourly-rate/hourly-rate.component';
import { UserManagementComponent } from './pages/device/settings/user-management/user-management.component';
import { SmartCTMComponent } from './pages/device/device-dashboard/smart-ctm/smart-ctm.component';
import { ChargerComponent } from './pages/device/device-dashboard/charger/charger.component';
import { GroupEnergyStatsComponent } from './pages/group/group-energy-stats/group-energy-stats.component';
import { ANC1Component } from "./pages/device/device-dashboard/anc1/anc1.component";
import { ANC2Component } from "./pages/device/device-dashboard/anc2/anc2.component";
import { XlumComponent } from "./pages/device/device-dashboard/xlum/xlum.component";
import { SchedulerAncComponent } from "./components/scheduler-anc/scheduler-anc.component";
import { OutButtonsComponent } from "src/app/components/scheduler-anc/out-buttons/out-buttons.component";
import { NimbleComponent } from "./pages/device/settings/nimble/nimble.component";
import { AncDeviceSettingsComponent } from "./pages/device/settings/anc-device-settings/anc-device-settings.component";
import { AncChannelsComponent } from "./pages/device/settings/anc-channels/anc-channels.component";
import { AncCalendarComponent } from "./pages/device/settings/anc-calendar/anc-calendar.component";
import { AncHolidayComponent } from "./pages/device/settings/anc-holiday/anc-holiday.component";
import { AncSeasonsComponent } from './pages/device/settings/anc-seasons/anc-seasons.component';
import { ModalHolidayCalendarComponent } from './components/ui/modal-holiday-calendar/modal-holiday-calendar.component';
import { AncProgramsComponent } from './pages/device/settings/anc-programs/anc-programs.component';
import { DlProgramsComponent } from './pages/device/settings/dl-programs/dl-programs.component';
import { LumSchedulerComponent } from './pages/device/settings/lum-scheduler/lum-scheduler.component';
import { LumAstcalComponent } from './pages/device/settings/lum-astcal/lum-astcal.component';
import { LumAlarmsComponent } from './pages/device/settings/lum-alarms/lum-alarms.component';

/*FIREBASE*/

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { A2Component } from "./pages/device/device-dashboard/a2/a2.component";
import { D2Component } from "./pages/device/device-dashboard/d2/d2.component";
import { AstroLumComponent } from "./pages/device/device-dashboard/astro-lum/astro-lum.component";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdminLayoutComponent,
    DeviceComponent,
    SettingsComponent,
    DeviceDashboardComponent,
    ConnectivityComponent,
    PasswordComponent,
    WifiComponent,
    ChannelsComponent,
    PowerComponent,
    OcppComponent,
    ErrorModalComponent,
    ProfileComponent,
    RegisterComponent,
    CardStateComponent,
    FooterComponent,
    CardHistoricComponent,
    LoadingPopupComponent,
    ModernErrorModalComponent,
    AllSettingsComponent,
    AdminComponent,
    AdminSearchComponent,
    RfidComponent,
    LogsComponent,
    FwupdateComponent,
    RecoveryComponent,
    ForgotComponent,
    CustomModalComponent,
    ModalConfirmComponent,
    VerificationModalComponent,
    DiagnosisHomeComponent,
    AddDeviceComponent,
    ModalSelectSerialComponent,
    UndefinedsPipe,
    ChargeSchedulerComponent,
    PowerSchedulerComponent,
    ModalSchedulerTaskComponent,
    AlertsDiagnosisComponent,
    SolarPriorityModalComponent,
    FilterLogsPipe,
    EthernetComponent,
    ModulesComponent,
    MqttApiComponent,
    DeveloperLayoutComponent,
    CardAnalyticsComponent,
    AbsPipe,
    StringifyPipe,
    ResetComponent,
    MultipleCommandComponent,
    ModalMainMeterComponent,
    ModalSecondaryMeterComponent,
    PowerNewComponent,
    DashboardComponent,
    PatTokenComponent,
    TestersComponent,
    TestersSearchPipe,
    CapitalizeFirstPipe,
    DeviceSettingsSplComponent,
    LinkageComponent,
    ModalCheckComponent,
    GeolocationComponent,
    NameComponent,
    CommaToSlashPipe,
    MqttComponent,
    JsonStringifyPipe,
    SubscriptionsComponent,
    NewGroupComponent,
    ViewGroupComponent,
    ModalAddGroupComponent,
    SplGroupComponent,
    ShowGroupComponent,
    GroupComponent,
    MapGroupComponent,
    CostsComponent,
    MarkdownPipe,
    TermsComponent,
    PowerCircleComponent,
    EnergyFlowLineComponent,
    ModalCookiesComponent,
    PrivacyPolicyComponent,
    RemoveBulletPipe,
    ConfirmationModalComponent,
    ElectricityRateComponent,
    FileUploadExportComponent,
    CrudModalComponent,
    HourlyRateComponent,
    UserManagementComponent,
    GroupEnergyStatsComponent,
    SmartCTMComponent,
    ChargerComponent,
    ANC1Component,
    ANC2Component,
    XlumComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    NgbModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
        defaultLanguage: 'en'
    }),
    ShowGroupCtmComponent,
    FiltersTimeComponent,
    UiSwitchModule.forRoot({
        size: 'small',
        color: '#007bff',
        switchColor: '#ffffff',
        defaultBgColor: '#6c757d',
        defaultBoColor: '#28a745',
        checkedLabel: '',
        uncheckedLabel: '',
        checkedTextColor: '#ffffff',
        uncheckedTextColor: '#ffffff'
    }),
    ToastrModule.forRoot({
        positionClass: 'toast-bottom-right',
    }),
    // Angular Material Modules
    MatDatepickerModule,
    MatMomentDateModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatTooltipModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTreeModule,
    MatButtonToggleModule,
    MatIconModule,
    MatRadioModule,
    MatCardModule,
    // Modules específicos
    SidebarModule,
    NavbarModule,
    // Módulos adicionales del shared module
    MatSelectModule,
    MatDialogModule,
    MatSnackBarModule,
    OutButtonsComponent,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatExpansionModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MarkdownModule,
    SchedulerAncComponent,
    OutButtonsComponent,
    NimbleComponent,
    AncDeviceSettingsComponent,
    AncChannelsComponent,
    AncCalendarComponent,
    AncHolidayComponent,
    AncSeasonsComponent,
    ModalHolidayCalendarComponent,
    A2Component,
    D2Component,
    AstroLumComponent,
    AncProgramsComponent,
    DlProgramsComponent,
    LumSchedulerComponent,
    LumAstcalComponent,
    LumAlarmsComponent,
],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: "es" },
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    NgbActiveModal,
    AuthService,
    TranslateService,
    provideHttpClient(withInterceptorsFromDi()),
    [CookieService]
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('es');
  }
}
